import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20warm%20dreamy%20anime%20style%20background%20with%20soft%20coral%20and%20golden%20gradient%2C%20floating%20manga%20page%20silhouettes%20and%20delicate%20sparkle%20effects%2C%20ethereal%20atmosphere%20with%20bokeh%20lights%2C%20gentle%20and%20inviting%20mood%2C%20clean%20composition%20suitable%20for%20call%20to%20action%20section&width=1600&height=600&seq=cta-bika-bg&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-black/35"></div>

      <div className="relative z-10 max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-white mb-4">
          准备好开始你的漫画之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-8 max-w-md mx-auto leading-relaxed">
          海量正版漫画等你来探索，现在就开始阅读吧！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/xiazai-jiaocheng"
            className="inline-flex items-center space-x-2 px-8 py-3.5 bg-accent-500 text-background-50 rounded-full font-medium text-sm hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-download-cloud-2-line"></i>
            <span>立即下载哔咔</span>
          </Link>
          <Link
            to="/category/gongneng-tese"
            className="inline-flex items-center space-x-2 px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full font-medium text-sm hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-star-line"></i>
            <span>探索功能特色</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;